import moment from "moment";
import { typeFormEdit } from "../components/Modal/type_modal";
import { ProgressIndicator } from "../components/ProgressIndicator/ProgressIndicator";
import { changeDateTimeZone, isAfterToDay, isBetweenPause, toDay } from "./dayjsHelper";
import { Endpoints } from "../config/type_endpoints";
import { truncateNumber } from "./operationMath";
import { replaceIdURL } from "./replaceId";

export const structureFormProject = (form, filters = { clickupid: [] }) => {
    let status = 0;
    let structureForm = {};
    const {
        name,
        description,
        development,
        existLimitDateProject,
        planning,
        startedDate,
        weeks,
        clientInformation,
        assetMoneyDLL,
        assetMoneyMX,
        providerMoneyDLL,
        providerMoneyMX,
        isOwn,
        ...restForm
    } = form;
    const clickupId = filters.clickupid.find((clickup) => clickup.name === name);
    if (clickupId === undefined) {
        status = 1;
        return { structureForm, status, msg: "No se encontró el id de clickup" };
    }
    if (planning > development.total) {
        status = 2;
        return { structureForm, status, msg: "Planeación no puede ser mas grande que las horas de desarollo" };
    }
    // const nameLowerCase = name.toLowerCase();
    // const isOwn = nameLowerCase.startsWith("interno");
    const startDate = moment(startedDate.$d).format("YYYY-MM-DD");
    const estimateStartDate = existLimitDateProject ? (restForm.deadLine ? moment(restForm.deadLine.$d).format("YYYY-MM-DD") : null) : null;
    const clientData = clientInformation.map((client) => {
        return {
            ...client,
            name: client.name ? client.name : "",
            rol: client.rol ? client.rol : "",
        };
    });

    const totalHours = truncateNumber(development.total + planning);
    structureForm = {
        name,
        startedDate: startDate,
        // deadLine: estimateStartDate,
        development: {
            total: development.total,
            web: 0,
            unity: 0,
            design: 0,
            modeling: 0,
        },
        weeks,
        planning,
        totalHours: totalHours,
        clickupSpace: clickupId.id,
        description,
        hasToBePublished: null,
        isOwn,
        assetMoneyDLL,
        assetMoneyMX,
        providerMoneyDLL,
        providerMoneyMX,
    };
    if (clientInformation.length > 0) {
        structureForm.client = clientData;
    }
    if (estimateStartDate) {
        structureForm.deadLine = estimateStartDate;
    }

    return { structureForm, status, msg: "" };
};

export const projectViewYear = (projects = [], year = moment().format("YYYY")) => {
    return projects.filter((project) => project.startDate === year);
};

const mapCategoriesToProject = (categories, categoryName) => {
    const category = categories.find((cat) => cat.name === categoryName);
    if (!category) {
        return {
            id: null,
            subCategories: [],
        };
    }
    return {
        id: category._id,
        subCategories: category.subCategories,
    };
};

const CATEGORY_NAMES = {
    AR: "AR",
    VR: "VR",
    WEB: "WEB",
    OTRO: "OTRO",
};

export const structureCategoriesForProject = (categories = []) => {
    return {
        categoriesAr: mapCategoriesToProject(categories, CATEGORY_NAMES.AR),
        categoriesVr: mapCategoriesToProject(categories, CATEGORY_NAMES.VR),
        categoriesWeb: mapCategoriesToProject(categories, CATEGORY_NAMES.WEB),
        categoriesOtro: mapCategoriesToProject(categories, CATEGORY_NAMES.OTRO),
    };
};

export const percentHours = (number = 0, styleFormat = {}) => {
    const status = ["success", "exception", "active"];
    let statusSelect = status[2];
    let colorSlide = "#ccc";
    if (number < 0) {
        colorSlide = "red";
    }
    if (number === 100) {
        statusSelect = status[0];
    } else if (number >= 101) {
        statusSelect = status[1];
    } else if (number >= 0 && number <= 99) {
        statusSelect = status[3];
    }
    return (
        <ProgressIndicator
            colorFormat={styleFormat}
            percent={number}
            status={statusSelect}
            propsProgress={{ strokeWidth: 10, trailColor: colorSlide }}
        />
    );
};

export const getStructureHoursFormProject = (areas = []) => {
    return {
        web: 0,
        unity: 0,
        design: 0,
        modeling: 0,
        planning: 0,
    };
};

const checkCategories = (form, array) => {
    let categoriesSelect = [];
    if (form === undefined) {
        return categoriesSelect;
    }

    const { id, subCategories } = array;

    subCategories.forEach((data) => {
        if (!form.includes(data)) {
            return;
        }
        const findIndex = categoriesSelect.findIndex((newCategory) => newCategory.id === id);
        if (findIndex === -1) {
            categoriesSelect.push({
                id: id,
                subCategories: [data],
            });
        } else {
            categoriesSelect[findIndex].subCategories = [...categoriesSelect[findIndex].subCategories, data];
        }
    });

    return categoriesSelect;
};

export const verificateTeamCorrect = (
    teamsDB = {
        leader: [],
        comercial: [],
        responsible: [],
        art3d: [],
        desing: [],
        web: [],
        unity: [],
    },
    teamBefore = [],
    form = {
        leader: [],
        comercial: [],
        responsible: [],
        art3d: [],
        desing: [],
        web: [],
        unity: [],
    }
) => {
    let users = [];
    const namesBack = {
        leader: "leaders",
        comercial: "peopleInChargeProject",
        responsible: "peopleInCharge",
        art3d: "art3d",
        desing: "design",
        web: "web",
        unity: "unity",
    };

    const arrayAdmin = [namesBack.leader, namesBack.comercial, namesBack.responsible];

    const notInYourArea = [];

    Object.entries(form).forEach(([key, value]) => {
        const isEqual = JSON.stringify(value) === JSON.stringify(teamBefore[key]);
        if (isEqual) {
            return;
        }

        //? Elementos eliminados
        const deleteTeam = teamBefore[key].filter((item) => !value.includes(item));
        //? Elementos agregados
        const addTeam = value.filter((item) => !teamBefore[key].includes(item));

        const namePosition = namesBack[key];
        const isAdmin = arrayAdmin.includes(namePosition);

        let structureJson = {
            memberId: null,
            isAdd: false,
            isAdmin: isAdmin,
            position: namePosition,
        };

        if (deleteTeam.length > 0) {
            deleteTeam.forEach((d) => {
                const findId = teamsDB[key].find((t) => t.name === d);
                if (!findId) {
                    notInYourArea.push({
                        ...structureJson,
                        name: d,
                    });
                    return;
                }
                users.push({
                    ...structureJson,
                    memberId: findId._id,
                });
            });
        }

        if (addTeam.length > 0) {
            addTeam.forEach((d) => {
                const findId = teamsDB[key].find((t) => t.name === d);
                if (!findId) {
                    notInYourArea.push({
                        ...structureJson,
                        name: d,
                        isAdd: true,
                    });
                    return;
                }
                users.push({
                    ...structureJson,
                    memberId: findId._id,
                    isAdd: true,
                });
            });
        }
    });

    if (notInYourArea.length > 0) {
        const allTeam = Object.values(teamsDB).flat();

        notInYourArea.forEach(({ name, ...restUser }) => {
            const findUserInAllTeam = allTeam.find((all) => all.name === name);
            if (!findUserInAllTeam) {
                return;
            }
            users.push({
                ...restUser,
                memberId: findUserInAllTeam._id,
            });
        });
    }

    return users;
};

export const getStructureFormEdit = (
    form,
    type = 0,
    filter = {
        categories: [],
        platforms: [],
        users: {},
        teamCurren: [],
    },
    id = 0,
    editMode = false
) => {
    let structureJson = {};
    let url = "";
    let payload = { status: 0, msg: "" };
    if (type === typeFormEdit.form_budget_hours) {
        if (editMode) {
            url = replaceIdURL(Endpoints.updateProject.calculatedHours, "spaceId", id);
            const { development, planning } = form;
            if (planning > development.total) {
                payload.status = 1;
                payload.msg = "Planeación no puede ser mayor que desarrollo";
            }
            structureJson = {
                developmentHours: development.total,
                planningHours: planning,
            };
        } else {
            url = replaceIdURL(Endpoints.updateProject.budgethours, "spaceId", id);
            const { development, isEvent, isTracing } = form;
            if (isEvent) {
                url += "?isEvent=true";
            }
            if (isTracing) {
                url += "?isTracing=true";
            }
            structureJson = {
                webHours: development.web,
                unityHours: development.unity,
                artHours: development.modeling,
                designHours: development.design,
            };
        }
    }
    if (type === typeFormEdit.form_dates) {
        url = replaceIdURL(Endpoints.updateProject.dates, "spaceId", id);
        if (form.existLimitDateProject) {
            structureJson = {
                deadLine: form.deadLine === "" ? "" : moment(form.deadLine.$d).format("YYYY-MM-DD"),
            };
        } else {
            structureJson = {
                expectedDate: form.expectedCloseDate === "" ? "" : moment(form.expectedCloseDate.$d).format("YYYY-MM-DD"),
            };
        }
    }
    if (type === typeFormEdit.form_infoclient) {
        url = replaceIdURL(Endpoints.updateProject.infocliente, "spaceId", id);
        structureJson = {
            client: form.clientInformation,
        };
    }
    if (type === typeFormEdit.form_inforProject) {
        url = replaceIdURL(Endpoints.updateProject.infoproject, "spaceId", id);
        let newPlatforms = [];
        let newCategories = [];
        filter.platforms.forEach((platform) => {
            if (form.platformIds.includes(platform.name)) {
                newPlatforms.push(platform._id);
            }
        });
        const { categoriesAr, categoriesVr, categoriesWeb, categoriesOtro } = filter.categories;
        const arArray = checkCategories(form.categorie.ar, categoriesAr);
        const vrArray = checkCategories(form.categorie.vr, categoriesVr);
        const webArray = checkCategories(form.categorie.web, categoriesWeb);
        const otroArray = checkCategories(form.categorie.otro, categoriesOtro);
        newCategories = [].concat(arArray, otroArray, vrArray, webArray);
        let typesProperties = [];
        if (form.maintenance) {
            typesProperties.push("mantenimiento");
        }
        if (form.hardware) {
            typesProperties.push("hardware");
        }
        if (form.categorie.metaverso) {
            typesProperties.push("metaverso");
        }
        structureJson = {
            description: form.description,
            platformIds: newPlatforms,
            types: typesProperties,
            categoryIds: newCategories,
        };
    }
    if (type === typeFormEdit.form_team) {
        const { userTeam } = form;
        url = replaceIdURL(Endpoints.updateProject.team, "spaceId", id);
        const verificationTeam = verificateTeamCorrect(filter.users, filter.teamCurren, userTeam);
        structureJson = {
            team: verificationTeam,
        };
    }
    return { structureJson, url, payload };
};

export const getStructureFormWorkTeam = (
    valueForm = {},
    dbInfo = {
        users: [],
        teamCurren: [],
    }
) => {
    const verificationTeam = verificateTeamCorrect(dbInfo.users, dbInfo.teamCurren, valueForm);
    return {
        team: verificationTeam,
    };
};

export const getStructureFormDetailsProject = (
    valueForm = {},
    dbInfo = {
        platforms: [],
        categories: [],
    }
) => {
    let newPlatforms = [];
    let newCategories = [];
    let typesProperties = [];

    newPlatforms = dbInfo.platforms.filter((platform) => valueForm.platforms.includes(platform.name)).map((platform) => platform._id);

    const { categoriesAr, categoriesVr, categoriesWeb, categoriesOtro } = dbInfo.categories;
    const arArray = checkCategories(valueForm.categorie.ar, categoriesAr);
    const vrArray = checkCategories(valueForm.categorie.vr, categoriesVr);
    const webArray = checkCategories(valueForm.categorie.web, categoriesWeb);
    const otroArray = checkCategories(valueForm.categorie.otro, categoriesOtro);

    newCategories = [].concat(arArray, otroArray, vrArray, webArray);

    if (valueForm.maintenance) {
        typesProperties.push("mantenimiento");
    }

    if (valueForm.hardware) {
        typesProperties.push("hardware");
    }

    if (valueForm.metaverso) {
        typesProperties.push("metaverso");
    }

    return {
        description: valueForm.description,
        platformIds: newPlatforms,
        types: typesProperties,
        categoryIds: newCategories,
    };
};

export const structureCategoriesForm = (categories = []) => {
    return categories.reduce(
        (prev, acc) => {
            return {
                ...prev,
                [acc.name.toLowerCase()]: acc.subCategories,
            };
        },
        {
            ar: [],
            vr: [],
            web: [],
            otro: [],
        }
    );
};

const checkDates = (dateSelect, today, startDate) => {
    if (!dateSelect) return null;

    const isTodayAfterInitDate = isAfterToDay(dateSelect, today);
    if (isTodayAfterInitDate) {
        return {
            isCreatePause: false,
            msgPause: "La fecha de inicio no puede ser después del día de hoy",
        };
    }

    const isInitDateBeforeStartDate = isAfterToDay(startDate, dateSelect);
    if (isInitDateBeforeStartDate) {
        return {
            isCreatePause: false,
            msgPause: "La fecha de inicio no puede ser antes del inicio del proyecto",
        };
    }

    return null;
};

const checkOnlyDate = (dateDB, pauseSelectInit, pauseSelectFinish) => {
    if (pauseSelectInit) {
        const isAfterDateDBByPausInit = isAfterToDay(pauseSelectInit, dateDB);
        if (!isAfterDateDBByPausInit) {
            return {
                isCreatePause: false,
                msgPause: "Fecha selecciona es menor que la fecha de pausa del inicio",
            };
        }
    }

    if (pauseSelectFinish) {
        const isAfterDateDBByPauseFinish = isAfterToDay(pauseSelectFinish, dateDB);
        if (!isAfterDateDBByPauseFinish) {
            return {
                isCreatePause: false,
                msgPause: "Fecha selecciona es menor que la fecha de pausa del final",
            };
        }
    }

    return null;
};

const verificatePauseDate = (dateForVerification, pauseInit, pauseFinish) => {
    if (!dateForVerification) return false;

    const isExistBetweenInitOrFinish = isBetweenPause(dateForVerification, pauseInit, pauseFinish);
    if (isExistBetweenInitOrFinish) {
        return true;
    }

    return false;
};

const checkPauses = (pauses = [], initDate, finishDate) => {
    if (pauses.length === 0) return null;
    for (const p of pauses) {
        const pauseDateInit = changeDateTimeZone(p.init).dayFormat;
        const pauseDateClose = changeDateTimeZone(p.close).dayFormat;

        if (pauseDateInit === "" || pauseDateClose === "") {
            const comparateDateInit = checkOnlyDate(pauseDateInit, initDate, finishDate);
            const comparateDateFinish = checkOnlyDate(pauseDateInit, initDate, finishDate);
            if (comparateDateInit) return comparateDateInit;
            if (comparateDateFinish) return comparateDateFinish;
        } else {
            const verificationPauseInit = verificatePauseDate(initDate, pauseDateInit, pauseDateClose);
            const verificationPauseFinish = verificatePauseDate(finishDate, pauseDateInit, pauseDateClose);

            if (verificationPauseInit) {
                return {
                    isCreatePause: false,
                    msgPause: "Ya existe una pausa en la fecha de inicio",
                };
            }

            if (verificationPauseFinish) {
                return {
                    isCreatePause: false,
                    msgPause: "Ya existe una pausa en la fecha de final",
                };
            }
        }
    }
    return null;
};

export const verificationDatePauses = (valueForm, start, pauses = []) => {
    const { initDate = null, finishDate = null, initPause = null } = valueForm;
    const today = toDay().dayFormat;
    const startDate = changeDateTimeZone(start).dayFormat;

    if (initDate && finishDate) {
        const isFinishDateBeforeInitDateSelect = isAfterToDay(initDate, finishDate);
        if (isFinishDateBeforeInitDateSelect) {
            return {
                isCreatePause: false,
                msgPause: "El dia final ó inicio seleccionado esta antes de un uno de los dias",
            };
        }
    }

    if (initPause) {
        const isFinishDateBeforeInitDate = isAfterToDay(initPause, finishDate);
        if (isFinishDateBeforeInitDate) {
            return {
                isCreatePause: false,
                msgPause: "El dia final seleccionado es antes que el inicio de pausa",
            };
        }
    }

    const finishDateResult = checkDates(finishDate, today, startDate);
    if (finishDateResult) {
        return finishDateResult;
    }

    const initDateResult = checkDates(initDate, today, startDate);
    if (initDateResult) {
        return initDateResult;
    }
    const initPauses = checkPauses(pauses, initDate, finishDate);
    if (initPauses) {
        return initPauses;
    }

    return {
        isCreatePause: true,
        msgPause: "",
    };
};

export const areasInmersysDevelopment = ["planeación", "diseño ui/ux", "arte 3d", "programación web", "programación unity"];
